var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlayFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m1.604.057 7.37 7.316 2.02-2.02L2.06.194a1 1 0 0 0-.457-.138m-.617.34a.84.84 0 0 0-.106.415v14.217c0 .114.024.217.064.308l7.539-7.486zM11.61 5.703 9.452 7.851 11.61 9.99l2.638-1.51c.374-.217.428-.492.425-.638-.004-.242-.157-.468-.415-.607-.224-.12-1.893-1.092-2.648-1.53M8.973 8.33 1.54 15.699a.84.84 0 0 0 .383-.106c.291-.17 6.178-3.573 6.178-3.573l2.903-1.67z"
})));
export default SvgPlayFilled;